import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { ROLE_LABELS } from '../../utils/roles';

export default function AccessDenied() {
    const navigate = useNavigate();
    const { user } = useAuthStore();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center' }}>
            <div style={{ fontSize: 64, marginBottom: 16 }}>🚫</div>
            <h2 style={{ fontSize: 24, fontWeight: 800, color: '#dc2626', margin: 0 }}>Access Denied</h2>
            <p style={{ color: '#64748b', fontSize: 14, marginTop: 8, marginBottom: 4 }}>
                You do not have permission to access this section.
            </p>
            {user && (
                <p style={{ color: '#94a3b8', fontSize: 13 }}>
                    Your role: <strong>{ROLE_LABELS[user.role] || user.role}</strong>
                </p>
            )}
            <p style={{ color: '#94a3b8', fontSize: 12, marginBottom: 24 }}>
                Please contact the IT Manager or Admin if you need access.
            </p>
            <button onClick={() => navigate('/')}
                style={{ padding: '10px 28px', background: '#1e3a5f', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                ← Back to Dashboard
            </button>
        </div>
    );
}
